module.exports = __webpack_public_path__ + "static/media/logo-2.d44d60f2.png";